import { Box } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getBranchList, getOwnParentCompany, updateAlertError, updateModal } from '../../../../store/common/common_action'
import {
  getDispatchReportSummaryFilterData,
  getDispatchMemoDetailFilterData,
  getChallanWiseDispatchData,
} from '../../../../store/reports/reports_action'
import {
  getDispatchReportInputFilters,
  getDispatchReportDetailsFilter,
  getCargoSettingFilterData,
} from '../../../../store/reports/reports_action'
import { getOwnChildBranches, getDispatchReportDetailsData } from '../../../../store/reports/reports_action'
import { nameAll, reportOptionsDetailedViewDispatchFilter, reportTypeDispatchFilter } from '../../../common/constants'
import { reportViewDispatchFilter, reportOptionsSummaryViewDispatchFilter } from '../../../common/constants'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import {
  appendToUrl,
  diffInMonths,
  extractAndFilter,
  focusElemnt,
  isEmpty,
  navigation3,
  removeDuplicatesFromArray,
  removeDuplicatesFromArray1,
} from '../../../common/helper'
import { modeAllPayments, paymentModesWithAll } from '../../../common/paymentsMode'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as lb from '../reportLables'
import * as urls from '../oldReportsUrls'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import DispatchReportTable from './DispatchTable'
import {
  GroupData,
  GroupDataVWC,
  GroupDataVWCSecond,
  IsAppGroup,
  groupDataByKey,
  groupDataByVehicleAndPayment,
} from '../common/reportUtils'
import {
  coloumnDispatchDetails11,
  coloumnDispatchDetails12,
  coloumnDispatchDetails1WithFormatLR,
  coloumnDispatchDetails2,
  showOnlyToPayCol,
  showOnlyToPayColTwo,
  showOnlyToPayColWithFormat,
  showOnlyToPayColWithFormatTwo,
  withPaymentTypeCol,
  withPaymentTypeColWithFormat,
  withVehicleANdChartCol,
  withVehicleANdChartColTwo,
} from '../common/reportConstants'
import ManageColumns from '../../../common/ManageColumnsUI'
import { updateAlert } from '../../../../store/common/common_action'
import VehiclewiseDispatch from './Detailed/VehiclewiseDispatch'
import WithVehicleAndChart from './Detailed/WithVehicleAndChart'
import WithPaymentType from './Detailed/WithPaymentType'
import ShowOnlyToPayAmt from './Detailed/ShowOnlyToPayAmt'
import { useDispatch } from 'react-redux'
import { DEMO_COMPANY, DEUBEY_JS, DUBEY_TRAVEL, JAIN_COMPANY_ID, JAIN_NEW, RAJESH_TRANSPORT, SHRI_BABU, STA_COMPANY_ID} from '../../../../helper/companyIdhardcode'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import { useAtom } from 'jotai'

const DispatchReport = (props) => {
  const {
    data,
    getDispatchReportDetailsFilter,
    updateAlertError,
    getDispatchMemoDetailFilterData,
    getCargoSettingFilterData,
    updateAlert,
  } = props
  const { getDispatchReportDetailsData, getDispatchReportSummaryFilterData, updateModal } = props
  const { common, reports } = data
  const dispatch = useDispatch()
  const { loginData, showModal, modalType, roleRights, companySettings } = common
  const { intCompanyID, intUserID } = loginData
  const {
    dispatchDetailsData,
    dispatchDetailsTableData,
    dispatchSummaryTableData,
    DispatchMemoDetailTableData,
    cargoSettingFilterData,
    challanWiseDispatchTableData,
  } = reports
  const allownFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const DispatchReportPortrait = companySettings?.[0]?.DispatchReportPortrait || 0
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const coloumnDispatchDetails1 = loginCountryId === 2 ? coloumnDispatchDetails12 : coloumnDispatchDetails11
  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFromBranch, setSelFromBranch] = useState('')
  const [selDestCity, setSelDestCity] = useState(nameAll)
  const [selBranch, setSelBranch] = useState(nameAll)
  const [selVehicle, setSelVehicle] = useState(nameAll)
  const [selPaymentTpe, setSelPaymentType] = useState(modeAllPayments)
  const [reportType, setReportType] = useState(reportTypeDispatchFilter[0])
  const [showSummaryReport, setShowSummaryReport] = useState(reportViewDispatchFilter[1])
  const [detailedFilter, setDetailedFilter] = useState()
  const [paymentWiseData, setPaymentWiseData] = useState([])
  const [groupDataSecond, setGroupDataSecond] = useState([])
  const [summaryFilter, setSummaryFilter] = useState([])
  const [vehicleGroupData, setVehicleGroupData] = useState([])
  const [showReport, setShowReport] = useState(false)
  const [paymentSummary, setPaymentSummary] = useState()
  const [paymentWiseVehicleData, setPaymentWiseVehicleData] = useState([])
  const [reportOptionsData, setReportOptionsData] = useState(reportOptionsSummaryViewDispatchFilter)
  const [manageColumn, setManageColumn] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [vehicleData, setVehicleData] = useState([])
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}
  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany =
        ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) ||
        ChildCompanyList[0];
      setSelCompany(defaultCompany);
    } else {
      setSelCompany({
        CompanyID: loginData.intCompanyID,
        CompanyName: loginData.strCompanyName
      });
    }
  }, [ChildCompanyList, AllowGroupofCompanies]);
    useEffect(() => {
      if (!isEmpty(loginData)) {
        const body = {
          intCompanyID: intCompanyID,
          UserID: intUserID
        }
        fetchChildCompanyList(body)
      }
    }, [loginData])
  useEffect(() => {
    if (dispatchDetailsData && dispatchDetailsData.length > 0) {
      setVehicleData(
        removeDuplicatesFromArray1(
          extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true, 'DispatchedToCityIDFilter'),
          'id',
          'name'
        )
      )
    }
  }, [dispatchDetailsData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!localStorage.getItem('isUpdated')) {
      localStorage.removeItem('coloumnDispatchDetails1')
      localStorage.removeItem('coloumnDispatchDetails2')
      localStorage.setItem('isUpdated', 'true')
    }
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  //  const DispatchReportPortrait = 1
  const makeColumnsMandatory = (columns, fields = []) => {
    return columns.map(col =>
      fields.includes(col.field)
        ? { ...col, isMandatory: true, isDefault: true }
        : col
    )
  }
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        const localColoumnDispatchDetails1 = await getLocalData('keyVehicleWiseDisptchCol1_1011')
        const localcolDispatchDetails1WithFormatLR = await getLocalData('keyDispatchDetailsFormatLR1_1211')
        const localColoumnDispatchDetails2 = await getLocalData('KeyVehicleWiseDisptchCol2_0708')
        const localWithVehicleANdChartCol =
          loginCountryId !== 2 ? await getLocalData('KeyVehicleAndChartCol_0708') : await getLocalData('KeyVehicleAndChartCol2_0708')
        const localWithPaymentTypeCol = await getLocalData('KeyPaymentTypeCol_0708')
        const localWithPaymentTypeColWithFormat = await getLocalData('KeyPaymentTypeColWithFormat_0708')
        const LoaclShowOnlyToPayCol =
          loginCountryId !== 2 ? await getLocalData('KeyOnlyToPayCol_0708') : await getLocalData('KeyOnlyToPayCol2_0708')
        const LoaclShowOnlyToPayColWithFormat =
          loginCountryId !== 2 ? await getLocalData('KeyOnlyToPayColWithFormat_0708') : await getLocalData('KeyOnlyToPayColWithFormat2_0708')
        let data = []
        if (detailedFilter?.id === 0) {
          if (reportType?.id === 0) {
            if (allownFormatLR === 3) {
              data = localcolDispatchDetails1WithFormatLR || coloumnDispatchDetails1WithFormatLR
            } else {
              data = localColoumnDispatchDetails1 || coloumnDispatchDetails1
              if (loginData?.intCompanyID === STA_COMPANY_ID) {
                data = data.map((col) => {
                  if (col.field === "OperatorHamaliChg") {
                    return {
                      ...col,
                      header: "ToPay \nCharge",
                      pdfHead: "ToPay \nCharge",
                    };
                  } else if (col.field === "OptHamaliGST") {
                    return {
                      ...col,
                      header: "Ham+ToPay\nCharge GST",
                      pdfHead: "Ham+ToPay\nCharge GST",
                    };
                  }
                  return col;
                });
              }
            }
          } else {
            data = localColoumnDispatchDetails2 || coloumnDispatchDetails2
          }
        } else if (detailedFilter?.id === 1) {
          if (loginCountryId !== 2) {
            data = localWithVehicleANdChartCol || withVehicleANdChartCol
          }else {
            data = localWithVehicleANdChartCol || withVehicleANdChartColTwo
          }
          if (UseToPayAsCOD === 1) {
            data = data.map((col) => {
              if (col.field === "topayCount") {
                return { ...col, header: "COD\nLRs", pdfHead: "COD\nLRs" };
              } else if (col.field === "totalToPayCodFreight") {
                return { ...col, header: "COD\nFreight", pdfHead: "COD\nFreight" };
              } else if (col.field === "totalToPayCodGstOther") {
                return { ...col, header: "COD\nGST+Oth", pdfHead: "COD\nGST+Oth" };
              }
              return col;
            });
          }
        } else if (detailedFilter?.id === 2) {
          if (allownFormatLR === 3) {
            data = localWithPaymentTypeColWithFormat || withPaymentTypeColWithFormat
          } else {
            data = localWithPaymentTypeCol || withPaymentTypeCol
          }
        } else if (detailedFilter?.id === 3) {
          if (allownFormatLR === 3) {
            if (loginCountryId !== 2) {
              data = LoaclShowOnlyToPayColWithFormat || showOnlyToPayColWithFormat
            } else {
              data = LoaclShowOnlyToPayColWithFormat || showOnlyToPayColWithFormatTwo
            }
          } else {
            if (loginCountryId !== 2) {
              data = LoaclShowOnlyToPayCol || showOnlyToPayCol
            } else {
              data = LoaclShowOnlyToPayCol || showOnlyToPayColTwo
            }
          }
          if (UseToPayAsCOD === 1) {
            data = data.map((col) => {
                if (col.field === "2") return { ...col, header: "COD"};
                if (col.field === "7") return { ...col, header: "COD (Manual)" };
                if (col.field === "9") return { ...col, header: "COD (DDDV)"};
                return col;
              }).filter((col) => col.field !== "4");
          }
        }
        if (DispatchReportPortrait === 1) {
          if (loginData?.intCompanyID === SHRI_BABU) {
            const removeFields = ['BookingDateTime', 'ItemDetails']
            data = data.filter(col => !removeFields.includes(col.field))
            data = makeColumnsMandatory(data, ['SenderName', 'RecName'])
          }
          data = data.filter((item) => item.isMandatory === true)
        }
        if ([DUBEY_TRAVEL, DEUBEY_JS].includes(intCompanyID)) {
          const idx = data.findIndex(item => item.header === 'Total');
          if (idx !== -1) {
            data[idx] = { ...data[idx], isMandatory: false };
          }
        }
        if (loginCountryId === 2) {
          data = data.map((col) => {
            if (col.field === "Insurance") {
              return {
                ...col,
                header: "Insurance\nCharge",
                pdfHead: "Insurance\nCharge",
              };
            }
            return col;
          });
        }
        if (RAJESH_TRANSPORT === loginData?.intCompanyID) {
          const hasRestrictedFields = data.some(col =>
            ["SenderName", "RecName"].includes(col.field)
          );

          if (hasRestrictedFields) {
            data = data.filter(
              col => !["SenderName", "RecName"].includes(col.field)
            );
          }
        }
        setManageColumn(data)
      } catch (error) {
        // Handle error if necessary
        // setManageColumn(
        //   detailedFilter?.id === 0
        //     ? reportType?.id === 0
        //       ? allownFormatLR === 3
        //         ? coloumnDispatchDetails1WithFormatLR
        //         : coloumnDispatchDetails1
        //       : coloumnDispatchDetails2
        //     : detailedFilter?.id === 1
        //     ? loginCountryId !== 2
        //       ? withVehicleANdChartCol
        //       : withVehicleANdChartColTwo
        //     : detailedFilter?.id === 2
        //     ? allownFormatLR === 3
        //       ? withPaymentTypeColWithFormat
        //       : withPaymentTypeCol
        //     : detailedFilter?.id === 3
        //     ? allownFormatLR === 3
        //       ? loginCountryId !== 2
        //         ? showOnlyToPayColWithFormat
        //         : showOnlyToPayColWithFormatTwo
        //       : showOnlyToPayCol
        //     : []
        // )
        console.error(error)
      }
    }
    updateColumnDetails()
  }, [reportType?.id, detailedFilter?.id, allownFormatLR,DispatchReportPortrait])

  useEffect(() => {
    if (showSummaryReport?.id === 0) {
      setReportOptionsData(reportOptionsSummaryViewDispatchFilter)
      setDetailedFilter(reportOptionsSummaryViewDispatchFilter[0])
    } else {
      setReportOptionsData(reportOptionsDetailedViewDispatchFilter)
      setDetailedFilter(reportOptionsDetailedViewDispatchFilter[0])
    }
  }, [showSummaryReport])
  useEffect(() => {
    if (DispatchMemoDetailTableData?.length > 0) {
      if (detailedFilter?.Name === 'With Vehicle and Chart Date') {
        GroupDataVWC(DispatchMemoDetailTableData, setVehicleGroupData)
        GroupDataVWCSecond(DispatchMemoDetailTableData, setGroupDataSecond)
      }
    }
  }, [DispatchMemoDetailTableData])
  function groupDataByKeyWithCondition(arr = [], key) {
    return arr.reduce((groups, item) => {
      const groupKey = item[key]
      if (!groups[groupKey]) {
        groups[groupKey] = { data: [], totalNetAmount: 0, totalQuantity: 0 }
      }
      groups[groupKey].data.push(item)
      groups[groupKey].totalNetAmount +=
        item.PaymentTypeInt === 2 || item.PaymentTypeInt === 4 || item.PaymentTypeInt === 7 || item.PaymentTypeInt === 9
          ? item.NetAmount
          : 0
      groups[groupKey].totalQuantity += item.Quantity
      return groups
    }, {})
  }

  useEffect(() => {
    if (dispatchDetailsTableData.status === 'Success' && dispatchDetailsTableData?.Data?.Table.length > 0) {
      if (detailedFilter?.Name === 'Vehicle wise Dispatch') {
        GroupData(dispatchDetailsTableData?.Data?.Table, 'VehicleNoFilter', setVehicleGroupData, cargoSettingFilterData)
      } else if (detailedFilter?.Name === 'With Payment Type Group') {
        IsAppGroup(dispatchDetailsTableData?.Data?.Table, 'PaymentType', setVehicleGroupData)
      } else if (detailedFilter?.Name === 'Show Only ToPay Amount') {
        GroupData(dispatchDetailsTableData?.Data?.Table, 'VehicleNo', setVehicleGroupData, cargoSettingFilterData)
      }
      let groupedData = []
      if (detailedFilter?.Name === 'Show Only ToPay Amount') {
        groupedData = groupDataByKeyWithCondition(dispatchDetailsTableData?.Data?.Table, 'VehicleNo')
      } else {
        groupedData = groupDataByKey(dispatchDetailsTableData?.Data?.Table, 'VehicleNo')
      }
      // Flattening the resultArray
      const resultArray = Object.entries(groupedData).reduce((flattenedArr, [vehicleNo, data]) => {
        flattenedArr.push({ LRNO: `Vehicle No: ` + vehicleNo })
        flattenedArr.push(
          ...data.data.map((val) => ({
            ...val,
            NetAmount:
              val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 || val.PaymentTypeInt === 9
                ? val.NetAmount
                : 0,
          }))
        )
        flattenedArr.push({
          NetAmount: data.totalNetAmount,
          Quantity: data.totalQuantity,
          LRNO: `Total For Vehicle No: ` + vehicleNo,
          vehicleNo: '',
        })

        return flattenedArr
      }, [])
      let allTotalQuantity = 0
      let allTotalNetAmount = 0
      resultArray?.map((val) => {
        if (Object.keys(val).length === 4) {
          allTotalQuantity += val.Quantity
        }
        allTotalNetAmount +=
          val.PaymentTypeInt === 2 || val.PaymentTypeInt === 4 || val.PaymentTypeInt === 7 || val.PaymentTypeInt === 9 ? val.NetAmount : 0
      })
      resultArray.push({ NetAmount: allTotalNetAmount, Quantity: allTotalQuantity, LRNO: 'Total For ALL Vehicles', vehicleNo: '' })
      setPaymentSummary(resultArray)
      setPaymentWiseVehicleData(groupDataByVehicleAndPayment(dispatchDetailsTableData?.Data?.Table))
      const paymentWiseTotal = []
      dispatchDetailsTableData?.Data?.Table?.forEach(function (a) {
        if (!this[a.PaymentType]) {
          this[a.PaymentType] = {
            PaymentType: a.PaymentType,
            Quantity: 0,
            Freight: 0,
            DocumentCharges: 0,
            CartageAmount: 0,
            HamaliCharges: 0,
            OperatorHamaliChg: 0,
            ServiceTaxAmount: 0,
            CartageTax: 0,
            OptHamaliGST: 0,
            Insurance: 0,
            NetAmount: 0,
          }
          paymentWiseTotal.push(this[a.PaymentType])
        }
        this[a.PaymentType].Quantity += a.Quantity
        this[a.PaymentType].Freight += a.Freight
        this[a.PaymentType].DocumentCharges += a.DocumentCharges
        this[a.PaymentType].CartageAmount += a.CartageAmount
        this[a.PaymentType].HamaliCharges += a.HamaliCharges
        this[a.PaymentType].OperatorHamaliChg += a.OperatorHamaliChg
        this[a.PaymentType].ServiceTaxAmount += a.ServiceTaxAmount
        this[a.PaymentType].CartageTax += a.CartageTax
        this[a.PaymentType].OptHamaliGST += a.OptHamaliGST
        this[a.PaymentType].Insurance += a.Insurance
        this[a.PaymentType].NetAmount += a.NetAmount
      }, Object.create(null))
      let quantityTotal = 0
      let frieght = 0
      let docCharge = 0
      let cartege = 0
      let hamali = 0
      let operatorHamali = 0
      let frieghtGst = 0
      let cartageGst = 0
      let hamaliTotal = 0
      let valuation = 0
      let NetAmountTotal = 0
      paymentWiseTotal?.map((val) => {
        quantityTotal += Number(val.Quantity)
        frieght += Number(val.Freight)
        docCharge += Number(val.DocumentCharges)
        cartege += Number(val.CartageAmount)
        hamali += Number(val.HamaliCharges)
        operatorHamali += Number(val.OperatorHamaliChg)
        frieghtGst += Number(val.ServiceTaxAmount)
        cartageGst += Number(val.CartageTax)
        hamaliTotal += Number(val.OptHamaliGST)
        valuation += Number(val.Insurance)
        NetAmountTotal += Number(val.NetAmount)
      })
      paymentWiseTotal?.push({
        PaymentType: `Total For Vehicle No`,
        Quantity: quantityTotal.toFixed(2),
        Freight: frieght.toFixed(2),
        DocumentCharges: docCharge.toFixed(2),
        CartageAmount: cartege.toFixed(2),
        HamaliCharges: hamali.toFixed(2),
        OperatorHamaliChg: operatorHamali.toFixed(2),
        ServiceTaxAmount: frieghtGst.toFixed(2),
        CartageTax: cartageGst.toFixed(2),
        OptHamaliGST: hamaliTotal.toFixed(2),
        Insurance: valuation.toFixed(2),
        NetAmount: NetAmountTotal.toFixed(2),
      })
      setPaymentWiseData(paymentWiseTotal)
    }
  }, [dispatchDetailsTableData, detailedFilter])
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (dispatchDetailsData?.length > 0) {
      let BranchOption = [
        ...extractAndFilter(dispatchDetailsData, 'DispatchFromBranchFilter', 'DispatchFromBranchIDFilter', false, 'FromCityID'),
      ]
      const selectedBranch = BranchOption?.filter((val) => val.id === loginData?.intBranchID)
      if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
        setSelFromBranch({ cityId: loginData?.intBranchCityID, id: loginData?.intBranchID, name: loginData?.strBranchName })
      } else {
        if (selectedBranch?.length > 0) {
          setSelFromBranch(selectedBranch?.[0])
        } else {
          setSelFromBranch({ name: 'All', id: 0 })
        }
      }
    } else {
      setSelFromBranch('')
    }
  }, [dispatchDetailsData])
  const handleClick1 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else if (selFromBranch === '' || selFromBranch === ' ') {
      updateAlertError({ show: true, msg: 'Select Dispatch Branch', nextId: '' })
    } else {
      setShowReport(true)
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'Challan Wise Dispatch') {
        const data = {
          intBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
          intCompanyID: selCompany?.CompanyID,
          dispatchdate: fromDate.format('YYYY-MM-DD'),
          dispatchTodate: toDate.format('YYYY-MM-DD'),
          VehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.name,
          intUserID: intUserID,
          intConsignmentType: 0,
          AllowViewAllReport: 1,
        }

        dispatch(getChallanWiseDispatchData(data))
      } else if (showSummaryReport?.id === 1 && detailedFilter?.Name !== 'With Vehicle and Chart Date') {
        const data = {
          intFromCityID: 0,
          intFromBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
          intToCityID: selDestCity?.DestinationCity === 'All' ? 0 : selDestCity?.id,
          intToBranchID: selBranch?.DestinationBranch === 'All' ? 0 : selBranch.id,
          intCompanyID: selCompany?.CompanyID,
          dtFrom: fromDate.format('YYYY-MM-DD'),
          dtTo: toDate.format('YYYY-MM-DD'),
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.name,
          intPaymentType: selPaymentTpe === 0 ? 0 : selPaymentTpe?.typeId,
          LoginUserID: intUserID,
          IsOnlyCancelledDispatch: reportType?.Name === 'Dispatch' ? 0 : 1,
        }
        if (dispatchDetailsData.length > 0) {
          getDispatchReportDetailsData(data,UseToPayAsCOD )
        }
      } else if (
        detailedFilter?.Name === 'With Hamali and Cartage' ||
        detailedFilter?.Name === 'With Other Charges' ||detailedFilter?.Name === 'Other Charges' ||
        detailedFilter?.Name === 'Branch Summary' ||
        detailedFilter?.Name === 'Vehicle Wise Dispatch'
      ) {
        const data = {
          intFromCityID: 0,
          intFromBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
          intToCityID: selDestCity?.DestinationCity === 'All' ? 0 : selDestCity?.id,
          intToBranchID: selBranch?.DestinationBranch === 'All' ? 0 : selBranch.id,
          intCompanyID: selCompany?.CompanyID,
          dtFrom: fromDate.format('YYYY-MM-DD'),
          dtTo: toDate.format('YYYY-MM-DD'),
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.id,
          VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
          intPaymentType: selPaymentTpe === 0 ? 0 : selPaymentTpe?.typeId,
          // LoginUserID:intUserID,
          IsOnlyCancelledDispatch: reportType?.Name === 'Dispatch' ? 0 : 1,
        }
        getDispatchReportSummaryFilterData(data)
      } else if (detailedFilter?.Name === 'With Vehicle and Chart Date') {
        const data = {
          intFromCityID: 0,
          intFromBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
          intToCityID: selDestCity?.DestinationCity === 'All' ? 0 : selDestCity?.id,
          intToBranchID: selBranch?.DestinationBranch === 'All' ? 0 : selBranch.id,
          intCompanyID: selCompany?.CompanyID,
          dtFrom: fromDate.format('YYYY-MM-DD'),
          dtTo: toDate.format('YYYY-MM-DD'),
          intUserID: loginData?.intUserID,
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.name,
          // VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
          intPaymentType: selPaymentTpe === 0 ? 0 : selPaymentTpe?.typeId,
          LoginUserID: intUserID,
          IsOnlyCancelledDispatch: reportType?.Name === 'Dispatch' ? 0 : 1,
        }
        getDispatchMemoDetailFilterData(data)
      }
    }
  }
  const handleClick2 = () => {
    let url = ''
    if (showSummaryReport?.id === 1 && detailedFilter?.id === 3) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 6) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 5) {
      url = urls.challanWiseDispatch
      const urlData = urls.challanWiseDispatchParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.dispatchdate = fromDate?.format('YYYY-MM-DD')
      urlData.dispatchTodate = toDate?.format('YYYY-MM-DD')
      urlData.intBranchId = loginData?.intBranchID
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.intConsignmentType = 0
      urlData.AllowViewAllReport = 1
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    } else if ((showSummaryReport?.id === 1 && detailedFilter?.id === 1) || (showSummaryReport?.id === 0 && detailedFilter?.id === 0)) {
      url = urls.withVehicleAndCharteDate
      const urlData = urls.dispatchReportParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.intCompanyId = loginData?.intCompanyID
      urlData.FromDate = fromDate?.format('YYYY-MM-DD')
      urlData.ToDate = toDate?.format('YYYY-MM-DD')
      urlData.BranchId = loginData?.intBranchID
      urlData.BranchName = selFromBranch?.name
      urlData.CommonCompanyId = intCompanyID
      urlData.CommonUserId = intUserID
      urlData.ToCityId = selDestCity?.id
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.CompanyName = loginData?.strCompanyName
      urlData.CityName = `--All Cities--`
      urlData.WithoutVehicleGroup = showSummaryReport?.id === 1 && detailedFilter?.id === 2 ? `True` : `False`
      urlData.DBranchName = selBranch?.name === 'All' ? `--All--` : selBranch?.name
      urlData.BranchName = loginData?.strBranchName
      urlData.ToBranchID = selBranch?.id
      urlData.FromBranchID = selFromBranch?.id
      urlData.UserID = intUserID
      urlData.IsSummaryHamaliReport = showSummaryReport?.id === 0 && detailedFilter?.id == 1 ? 1 : 0 //with hamali and cartage
      urlData.IsSummaryOtherReport = showSummaryReport?.id === 0 && detailedFilter?.id == 2 ? 1 : 0 //with other charge
      urlData.IsBranchSummaryReport = showSummaryReport?.id === 0 && detailedFilter?.id == 3 ? 1 : 0 //branch summary
      urlData.IsVehicleDateSummaryReport =
        (showSummaryReport?.id === 1 && detailedFilter?.id == 1) || (showSummaryReport?.id === 0 && detailedFilter?.id == 0) ? 1 : 0 //with vehicle and charte date for dispatch
      urlData.IsVehicleDateSummaryOnlyReport = showSummaryReport?.id === 0 && detailedFilter?.id == 0 ? 1 : 0 //with vehicle and charte date for Summary
      urlData.VehicleID = selVehicle.id || 0
      urlData.CancelledDispatchOnly = reportType?.id === 1 ? 1 : 0
      urlData.PaymentType = selPaymentTpe.typeId
      urlData.mode = reportType?.id === 1 ? `CancelDispatch` : `Dispatch`
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    } else {
      url = urls.dispatchReport
      const urlData = urls.dispatchReportParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.intCompanyId = loginData?.intCompanyID
      urlData.FromDate = fromDate?.format('YYYY-MM-DD')
      urlData.ToDate = toDate?.format('YYYY-MM-DD')
      urlData.BranchId = loginData?.intBranchID
      urlData.BranchName = selFromBranch?.name
      urlData.CommonCompanyId = intCompanyID
      urlData.CommonUserId = intUserID
      urlData.ToCityId = selDestCity?.id
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.CompanyName = loginData?.strCompanyName
      urlData.CityName = `--All Cities--`
      urlData.WithoutVehicleGroup = showSummaryReport?.id === 1 && detailedFilter?.id === 2 ? `True` : `False`
      urlData.DBranchName = selBranch?.name === 'All' ? `--All--` : selBranch?.name
      urlData.BranchName = loginData?.strBranchName
      urlData.ToBranchID = selBranch?.id
      urlData.FromBranchID = selFromBranch?.id
      urlData.UserID = intUserID
      urlData.IsSummaryHamaliReport = showSummaryReport?.id === 0 && detailedFilter?.id == 1 ? 1 : 0 //with hamali and cartage
      urlData.IsSummaryOtherReport = showSummaryReport?.id === 0 && detailedFilter?.id == 2 ? 1 : 0 //with other charge
      urlData.IsBranchSummaryReport = showSummaryReport?.id === 0 && detailedFilter?.id == 3 ? 1 : 0 //branch summary
      urlData.IsVehicleDateSummaryReport =
        (showSummaryReport?.id === 1 && detailedFilter?.id == 1) || (showSummaryReport?.id === 0 && detailedFilter?.id == 0) ? 1 : 0 //with vehicle and charte date for dispatch
      urlData.IsVehicleDateSummaryOnlyReport = showSummaryReport?.id === 0 && detailedFilter?.id == 0 ? 1 : 0 //with vehicle and charte date for Summary
      urlData.VehicleID = selVehicle.id || 0
      urlData.CancelledDispatchOnly = reportType?.id === 1 ? 1 : 0
      urlData.PaymentType = selPaymentTpe.typeId
      urlData.mode = reportType?.id === 1 ? `CancelDispatch` : `Dispatch`
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const data = {
        intFromCityID: 0,
        intFromBranchID: 0,
        intToCityID: 0,
        intToBranchID: 0,
        intCompanyID: selCompany?.CompanyID,
        dtFrom: fromDate.format('YYYY-MM-DD'),
        dtTo: toDate.format('YYYY-MM-DD'),
        strVehicleNo: '--All--',
        intPaymentType: 0,
        LoginUserID: intUserID,
        IsOnlyCancelledDispatch: 0,
      }
      getDispatchReportDetailsFilter(data)
    }
  }
  const handlekeyDown = (e, prevId, nextId, currentId, currentButton) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      document.getElementById(nextId).focus()
    } else if (e.key === 'Escape') {
      document.getElementById(prevId).focus()
    } else if (e.key === ' ') {
      if (currentButton === 'go') {
        callFilterAPi()
      } else {
        document.getElementById(currentId).click()
      }
    }
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    if (detailedFilter?.id === 0 && reportType?.id === 0) {
      localStorage.setItem(
        allownFormatLR === 3 ? 'keyDispatchDetailsFormatLR1_1211' : 'keyVehicleWiseDisptchCol1_1011',
        JSON.stringify(items)
      )
    } else if (detailedFilter?.id === 0 && reportType?.id === 1) {
      localStorage.setItem('KeyVehicleWiseDisptchCol2_0708', JSON.stringify(items))
    } else if (detailedFilter?.id === 1) {
      localStorage.setItem(loginCountryId !== 2 ? 'KeyVehicleAndChartCol_0708' : 'KeyVehicleAndChartCol2_0708', JSON.stringify(items))
    } else if (detailedFilter?.id === 2) {
      localStorage.setItem(allownFormatLR === 3 ? 'KeyPaymentTypeColWithFormat_0708' : 'KeyPaymentTypeCol_0708', JSON.stringify(items))
    } else if (detailedFilter?.id === 3) {
      localStorage.setItem(
        allownFormatLR === 3
          ? loginCountryId !== 2
            ? 'KeyOnlyToPayColWithFormat_0708'
            : 'KeyOnlyToPayColWithFormat2_0708'
          : loginCountryId !== 2
          ? 'KeyOnlyToPayCol_0708'
          : 'KeyOnlyToPayCol2_0708',
        JSON.stringify(items)
      )
    }
  }
  const reportName = 'Dispatch'
  const headerData = {
    fromDate: moment(fromDate).format('MM/DD/YYYY'),
    toDate: moment(toDate).format('MM/DD/YYYY'),
    dispatchByBranch: selFromBranch?.dispatchByBranch || loginData?.strBranchName,
    destinationCity: selDestCity?.name,
    destinationBranch: selBranch?.name,
    vehicleNumber: selVehicle?.name,
    paymentType: selPaymentTpe?.name || 'All',
    reportType: reportType?.Name,
    reportView: showSummaryReport?.Name,
    reportOption: detailedFilter?.Name,
  }
  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSelDestCity(obj)
    setSelBranch(
      extractAndFilter(dispatchDetailsData, 'DispatchedToBranchFilter', 'DispatchedToBranchIDFilter', true).filter(
        (val) => val.id === obj.cityId || val.id == 0
      )?.[0]
    )
    if (obj.id === 0 && obj.name === 'All') {
      setVehicleData(
        removeDuplicatesFromArray1(
          extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true, 'DispatchedToCityIDFilter'),
          'id',
          'name'
        )
      )
    } else {
      let filterData = extractAndFilter(
        dispatchDetailsData,
        'VehicleNoForFilter',
        'VehicleIDForFilter',
        true,
        'DispatchedToCityIDFilter'
      ).filter((val) => val.cityId === obj.cityId)
      setVehicleData(filterData)
    }
  }
  const selectedDispatchByBranch = (obj) => {
    setShowReport(false)
    setSelFromBranch(obj)
    setSelDestCity(
      removeDuplicatesFromArray(
        extractAndFilter(
          dispatchDetailsData,
          'DispatchedToCityFilter',
          'DispatchedToCityIDFilter',
          true,
          'DispatchedToBranchIDFilter'
        ).filter((val) => val.id !== obj.cityId),
        'id'
      )?.[0]
    )
  }
  let BranchOption = [...([JAIN_COMPANY_ID,JAIN_NEW].includes(intCompanyID)? []:[{ name: 'All', id: 0, FromCityID: 0 }]),
  ...extractAndFilter(dispatchDetailsData, 'DispatchFromBranchFilter', 'DispatchFromBranchIDFilter', false, 'FromCityID'),
  ];
  let DestCityOption = [
    { name: 'All', id: 0, FromCityID: 0 },
    ...extractAndFilter(dispatchDetailsData, 'DispatchedToCityFilter', 'DispatchedToCityIDFilter', false, 'FromCityID'),
  ]
  let DestBranchOption = [
    { name: 'All', id: 0, FromCityID: 0 },
    ...extractAndFilter(dispatchDetailsData, 'DispatchedToBranchFilter', 'DispatchedToBranchIDFilter', false, 'FromCityID'),
  ]
  const destinationCityListTemp = dispatchDetailsData.reduce((acc, item) => {
    if(!acc.set.has(item.DispatchedToCityIDFilter)){
      acc.set.add(item.DispatchedToCityIDFilter)
      acc.list.push({name:item.DispatchedToCityFilter,id:item.DispatchedToCityIDFilter,cityId:item.DispatchedToCityIDFilter})
    }
    return acc
  }, {set:new Set(),list:[]}).list
  // const destinationCityList = [{ name: 'All', id: 0, cityId: 0 },...destinationCityListTemp.sort((a,b)=>a.name.localeCompare(b.name))]
  const destinationCityList = [
    { name: 'All', id: 0, cityId: 0 },
    ...destinationCityListTemp
      .filter((val) => val.id !== selFromBranch?.cityId)
      .sort((a, b) => a.name.localeCompare(b.name)),
  ]
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="selectCompnay"
              prevId={'generateDiv'}
              nextId={'ArrowForwardIosIcon1'}
              label="Selected Company"
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={AllowGroupofCompanies===1?false:true}
              onSelect={(val) => setSelCompany(val)}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={`From Dispatch Date`}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_dispatch_date'}
              label={'To Dispatch Date'}
              id="toDate"
              nextId={'ArrowForwardIosIcon2'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('ArrowForwardIosIcon2')
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            onClick={callFilterAPi}
            onKeyDown={(e) => handlekeyDown(e, 'fromDate', 'dispatchByBranch', 'ArrowForwardIosIconBtn', 'go')}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
              fontSize:'large'
            }}
          >
            GO
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.dispatchByBranch}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'ArrowForwardIosIcon2'}
              data={
                roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1
                  ? [
                      ...([JAIN_COMPANY_ID, JAIN_NEW].includes(intCompanyID) ? [] : [{ name: 'All', id: 0, FromCityID: 0 }]),
                      ...BranchOption?.filter((val) => val.cityId == loginData?.intBranchCityID),
                    ]
                  : BranchOption
              }
              dataKey={`name`}
              idKey={`id`}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              defaultvalue={BranchOption.length ? selFromBranch?.name : ''}
              value={selFromBranch?.name || ''}
              isObjArr={true}
              onSelect={(val) => selectedDispatchByBranch(val)}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.destination}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={destinationCityList}
              // data={removeDuplicatesFromArray(dispatchDetailsData, 'DispatchedToCityIDFilter')?.filter((val) => val)}
              dataKey={`name`}
              idKey={`id`}
              defaultvalue={DestCityOption.length ? selDestCity?.name : ''}
              value={selDestCity?.name || ''}
              onSelect={(val) => {
                selectedSourceCity(val)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.destinationBranch}
              id="destinationBranch"
              nextId={'vehicleList'}
              prevId={'destination'}
              data={
                extractAndFilter(
                  dispatchDetailsData,
                  'DispatchedToBranchFilter',
                  'DispatchedToBranchIDFilter',
                  true,
                  'DispatchedToCityIDFilter'
                ).filter(
                  (val) =>
                    val.id === 0 ||
                    (val.cityId === selDestCity.cityId &&
                      !(val.cityId === selFromBranch?.cityId && val.id === selFromBranch?.id)) // 🚫 same city+branch remove
                )
              }
              // data={removeDuplicatesFromArray(dispatchDetailsData,"DispatchedToBranchIDFilter").filter((val) => val.id === selDestCity.cityId || selDestCity.cityId === 0 || val.id === 0)||[]}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelBranch(val)
              }}
              defaultvalue={DestBranchOption.length ? selBranch?.name : ''}
              value={selBranch?.name || ''}
              width="100%"
              // minWidth="230px"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.vehicle}
              id="vehicleList"
              defaultvalue={'All'}
              value={selVehicle?.name || ''}
              data={vehicleData || []}
              // data={extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true, 'DispatchedToCityIDFilter').filter((val) => val.cityId === selDestCity.cityId || selDestCity.cityId === 0 || val.id === 0) || []}
              // data={extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true)}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelVehicle(val)
              }}
              nextId={'paymentBookingType'}
              prevId={'destinationBranch'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="paymentBookingType"
              label={lb.paymentType}
              isObjArr={true}
              onSelect={(val) => {
                setShowReport(false)
                setSelPaymentType(val)
              }}
              // data={paymentModesWithAll || []}
              data={ (paymentModesWithAll || []).map((item) => { if (UseToPayAsCOD === 1) { if (item.typeId === 2) { return { ...item, name: 'COD' }; } if (item.typeId === 7) { return { ...item, name: 'COD Manual' }; } if (item.typeId === 9) { return { ...item, name: 'COD DDDV' }; } if (item.typeId === 4) { return null; } } return item; }).filter(Boolean) }
              dataKey={`name`}
              idKey={`typeId`}
              defaultvalue={modeAllPayments.name}
              nextId={'ReportType'}
              prevId={'vehicleList'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="ReportType"
              label={'Report Type'}
              data={reportTypeDispatchFilter}
              defaultvalue={reportTypeDispatchFilter[0].Name}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setReportType(val)
              }}
              nextId={'reportView'}
              prevId={'paymentBookingType'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="reportView"
              label={'Report View'}
              data={reportViewDispatchFilter}
              defaultvalue={reportViewDispatchFilter[1].Name}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setShowSummaryReport(val)
              }}
              nextId={'reportOption'}
              prevId={'ReportType'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="reportOption"
              label={'Report Option'}
              defaultvalue={detailedFilter?.Name || ''}
              value={detailedFilter?.Name || ''}
              data={reportOptionsData}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setDetailedFilter(val)
              }}
              nextId={'generateDiv'}
              prevId={'reportView'}
              width="230px"
            />
          </Item>
          <Item
            id="generateDiv"
            tabIndex={0}
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, showReport ? 'DispatchPrintBtn' : 'fromDate', 'reportOption', () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              prevId={'reportOption'}
              id1={'generateBtn'}
              // id="generateBtn"
              nextId={'fromDate'}
              onClick1={handleClick1}
              onClick2={handleClick2}
              disabled={false}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, display: 'none' }}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      {showReport && showSummaryReport?.id === 0 && (
        <DispatchReportTable
          disableExcel={disableExcel}
          groupDataSecond={groupDataSecond}
          paymentWiseVehicleData={paymentWiseVehicleData}
          paymentSummary={paymentSummary}
          loginData={loginData}
          paymentWiseTotal={paymentWiseData}
          tableindex={showSummaryReport?.id === 0 ? detailedFilter.id + 4 : detailedFilter.id}
          reportType={reportType}
          detailedFilter={detailedFilter}
          showSummaryReport={showSummaryReport}
          dispatchDetailsTableData={vehicleGroupData}
          challanWiseDispatchTableData={challanWiseDispatchTableData}
          dispatchSummaryTableData={dispatchSummaryTableData}
          DispatchMemoDetailTableData={DispatchMemoDetailTableData}
          selFromBranch={selFromBranch}
          selDestCity={selDestCity}
          selBranch={selBranch}
          fromDate={fromDate}
          toDate={toDate}
          selVehicle={selVehicle}
          selPaymentTpe={selPaymentTpe}
          manageColumn={manageColumn}
          setManageColumn={setManageColumn}
          cargoSettingFilterData={cargoSettingFilterData}
          headerData={headerData}
        />
      )}
      {showReport &&
        showSummaryReport?.id === 1 &&
        (detailedFilter?.id === 0 ? (
          <VehiclewiseDispatch
            UseToPayAsCOD={UseToPayAsCOD}
            loginCountryId={loginCountryId}
            disableExcel={disableExcel}
            updateModal={updateModal}
            loginData={loginData}
            selBranch={selBranch}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            columnDefs={manageColumn.filter((item) => item.isSelected && !item?.isSummaryHeader)}
            reportData={dispatchDetailsTableData}
            selectedFields={manageColumn
              .filter((item) => item.isSelected && !item?.isSummaryHeader)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            summarySelectedFields={manageColumn
              .filter((item) => item.isSelected && item?.isSummaryHeader)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            summaryColumn={manageColumn.filter((val) => val?.isSelected && val.isSummaryHeader)}
            fromDate={fromDate}
            toDate={toDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
            allownFormatLR={allownFormatLR}
          />
        ) : detailedFilter?.id === 1 ? (
          <WithVehicleAndChart
            disableExcel={disableExcel}
            updateModal={updateModal}
            loginData={loginData}
            selBranch={selBranch}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            columnDefs={manageColumn.filter((item) => item.isSelected)}
            reportData={DispatchMemoDetailTableData}
            selectedFields={manageColumn
              .filter((item) => item.isSelected)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            fromDate={fromDate}
            toDate={toDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        ) : detailedFilter?.id === 2 ? (
          <WithPaymentType
            disableExcel={disableExcel}
            updateModal={updateModal}
            loginData={loginData}
            selBranch={selBranch}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            columnDefs={manageColumn.filter((item) => item.isSelected)}
            reportData={dispatchDetailsTableData}
            selectedFields={manageColumn
              .filter((item) => item.isSelected)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            fromDate={fromDate}
            toDate={toDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
            allownFormatLR={allownFormatLR}
          />
        ) : detailedFilter?.id === 3 ? (
          <ShowOnlyToPayAmt
            UseToPayAsCOD={UseToPayAsCOD}
            disableExcel={disableExcel}
            updateModal={updateModal}
            loginData={loginData}
            selBranch={selBranch}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            reportData={dispatchDetailsTableData}
            fromDate={fromDate}
            toDate={toDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            columnDefs={manageColumn.filter((item) => item.isSelected && !item?.isSummaryHeader)}
            summaryColumn={manageColumn.filter((val) => val?.isSelected && val.isSummaryHeader)}
            detailedFilter={detailedFilter}
            selectedFields={manageColumn
              .filter((item) => item.isSelected && !item?.isSummaryHeader)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            summarySelectedFields={manageColumn
              .filter((item) => item.isSelected && item?.isSummaryHeader)
              .reduce((result, item) => ({ ...result, [item.field]: true }), {})}
            allownFormatLR={allownFormatLR}
          />
        ) : null)}
      {showModal && modalType === 'showManageColumn' && (
        <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getDispatchReportInputFilters,
  getDispatchReportDetailsFilter,
  getBranchList,
  getOwnChildBranches,
  getOwnParentCompany,
  getDispatchReportDetailsData,
  getDispatchReportSummaryFilterData,
  getDispatchMemoDetailFilterData,
  updateAlertError,
  updateModal,
  getCargoSettingFilterData,
  updateAlert,
}
export default connect(mapStateToProps, mapDispatchToProps)(DispatchReport)
